import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useNotification from '@/shared/hooks/UseNotification';

const CONFLICT = 409;

const useHandleSaveContactError = () => {
  const { t } = useTranslation(['errors']);
  const { sendDefaultError, sendNotification } = useNotification();

  return useCallback(
    (error: unknown) => {
      if ((error as { data?: { httpStatus?: number } })?.data?.httpStatus === CONFLICT) {
        sendNotification({
          header: t('errors:conflict'),
          message: t('errors:contactWithSameInformationAlreadyExists'),
          variant: 'error',
        });
        return;
      }

      sendDefaultError(error);
    },
    [sendDefaultError, sendNotification, t],
  );
};

export default useHandleSaveContactError;
